module.exports = __webpack_public_path__ + "img/icon (7).c0232506.png";